import React, { useMemo } from 'react';
import LazyLoad from 'react-lazyload';
import { number, string, oneOf } from 'prop-types';

const StoreBadgeBase = ({ width, languageRegionCode, className, variant }) => {
  const shortRegionCode = languageRegionCode.split('-')[0];
  const style = { width };

  let fileName = 'app_store';
  let altText = 'App Store';
  let storeUrl = 'https://alltrails.io/QIH5RaBfOP';

  const src = useMemo(() => {
    if (variant === 'google') {
      fileName = 'google_play';
      altText = 'Google Play';
      storeUrl = 'https://alltrails.io/mtsb5iMfOP';
    }

    return `https://cdn-assets.alltrails.com/assets/images/stores/${fileName}_${shortRegionCode}.png`;
  }, [variant]);

  const trackClick = () => {
    _gaq.push(['_trackEvent', variant, 'mobile-badge', 'clicked']);
  };

  return (
    <a href={storeUrl} target="_blank" rel="noreferrer" onClick={trackClick}>
      <LazyLoad>
        <img style={style} src={src} className={className} alt={altText} />
      </LazyLoad>
    </a>
  );
};

StoreBadgeBase.propTypes = {
  width: number.isRequired,
  variant: oneOf(['apple', 'google']).isRequired,
  languageRegionCode: string,
  className: string
};

StoreBadgeBase.defaultProps = {
  languageRegionCode: 'en-US',
  className: ''
};

export default StoreBadgeBase;
